<!-- Adds locked or unlocked icon to the device image if the device
 is password protected or the user successfully authenticated locked device.  -->
<div *ngIf="!isVirtual && isPasswordEnabled">
	<img class="sh-device-state-icon" *ngIf="!isAuthenticated" src="./assets/icons/lock-only-locked.svg" />
	<img class="sh-device-state-icon" *ngIf="isAuthenticated" src="./assets/icons/lock-only-unlocked.svg" />
</div>
